export function initSliders() {
  document.querySelectorAll('.c-slider').forEach(initSlider);
}

function addPassiveListener(element, event, callback) {
  element.addEventListener(event, callback, {passive: true});
}

function removePassiveListener(element, event, callback) {
  element.removeEventListener(event, callback, {passive: true});
}

function initSlider(slider) {
  if (!slider) return;

  const slidesWrapper = slider.querySelector(".c-slides");
  const slides = slider.querySelectorAll(".c-slide");
  if (!slidesWrapper || slides.length < 2) return;

  const duration = parseInt(slider.dataset.duration) ?? 7000;
  const slideDuration = parseInt(slider.dataset.slideDuration) ?? 1000;
  const isAutoPlayEnabled = slider.dataset.isAutoPlay === 'true' || false;
  const isPauseOnHover = (slider.dataset.pauseOnHover === 'true' && isAutoPlayEnabled) ?? true;
  let slideId = 0;
  let isAutoPlay = false;
  let timeout;
  let isTimeout = false;
  let touchStartX = 0;
  let touchEndX = 0;

  slider.style.setProperty("--animation-duration", `${slideDuration}ms`);

  slides[0].classList.add("current");
  const indicators = slider.querySelectorAll(".c-indicator");
  if (indicators.length > 0) indicators[0].classList.add("current");

  for (const [index, slide] of slides.entries()) {
    slide.dataset.index = index;
    if (indicators[index]) indicators[index].dataset.index = index;
  }

  const prev = slider.querySelector('.arrow-prev');
  const next = slider.querySelector('.arrow-next');

  if (prev && next) {
    addPassiveListener(prev, "click", slideToPrev);
    addPassiveListener(next, "click", slideToNext);
  }

  const observerOptions = {root: null, threshold: 0.5};
  const observer = new IntersectionObserver(observerCallback, observerOptions);
  observer.observe(slider);

  for (const indicator of indicators) {
    addPassiveListener(indicator, "click", handleIndicatorClick);
  }

  function observerCallback(entries, _) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        if (isAutoPlayEnabled) {
          startAutoPlay();

          if (isPauseOnHover) {
            addPassiveListener(slider, "mouseenter", stopAutoPlay);
            addPassiveListener(slider, "mouseleave", startAutoPlay);
          }
        }

        addPassiveListener(window, "keydown", arrowKeyHandler);
        addPassiveListener(slidesWrapper, "touchstart", handleTouchStart);
        addPassiveListener(slidesWrapper, "touchmove", handleTouchMove);
        addPassiveListener(slidesWrapper, "touchend", handleTouchEnd);
      } else {
        if (isAutoPlayEnabled && isPauseOnHover) {
          removePassiveListener(slider, "mouseover", stopAutoPlay);
          removePassiveListener(slider, "mouseout", startAutoPlay);
        }

        removePassiveListener(window, "keydown", arrowKeyHandler);
        removePassiveListener(slidesWrapper, "touchstart", handleTouchStart);
        removePassiveListener(slidesWrapper, "touchmove", handleTouchMove);
        removePassiveListener(slidesWrapper, "touchend", handleTouchEnd);
      }
    });
  }

  function slideTo(index) {
    if (isTimeout) return;

    const currentSlide = slider.querySelector(".c-slide.current");
    const nextSlide = slides[index];
    if (!currentSlide || !nextSlide || currentSlide === nextSlide) return;

    const currentIndicator = slider.querySelector(".c-indicator.current");
    const nextIndicator = slider.querySelector(`.c-indicator[data-index="${index}"]`);

    isAutoPlayEnabled && stopAutoPlay();
    isTimeout = true;
    currentSlide.classList.remove("current");
    currentSlide.classList.add("prev");
    nextSlide.classList.add("current");

    if (currentIndicator) {
      currentIndicator.classList.remove("current");
      nextIndicator.classList.add("current");
    }

    setTimeout(() => {
      isTimeout = false;
      slider.classList.remove("slide-left");
      slider.classList.remove("slide-right");
      currentSlide?.classList.remove("prev");
    }, slideDuration + 100);
  }

  function slideToNext() {
    if (isTimeout) return;
    slideId = slideId + 1;
    if (slideId >= slides.length) slideId = 0;
    slider.classList.add("slide-left");
    slideTo(slideId);
  }

  function slideToPrev() {
    if (isTimeout) return;
    slideId = slideId - 1;
    if (slideId < 0) slideId = slides.length - 1;
    slider.classList.add("slide-right");
    slideTo(slideId);
  }

  function arrowKeyHandler(event) {
    if (event.key === "ArrowLeft") slideToPrev();
    if (event.key === "ArrowRight") slideToNext();
  }

  function startAutoPlay() {
    isAutoPlay = true;
    timeout = setTimeout(() => {
      slideToNext();
      startAutoPlay();
    }, duration);
  }

  function stopAutoPlay() {
    isAutoPlay = false;
    if (timeout) clearTimeout(timeout);
  }

  function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
  }

  function handleTouchMove(e) {
    touchEndX = e.touches[0].clientX;
  }

  function handleTouchEnd() {
    if (touchEndX < touchStartX) slideToNext();
    if (touchEndX > touchStartX) slideToPrev();
    touchStartX = 0;
    touchEndX = 0;
  }

  function handleIndicatorClick(e) {
    if (isTimeout) return;
    const index = e.target.dataset.index;
    if (!index) return;
    slider.classList.add(index > slideId ? "slide-left" : "slide-right");
    slideId = parseInt(index);
    slideTo(slideId);
  }
}
